export default __webpack_public_path__ + "static/media/blog.fffb887b.png";